<template>
  <div>
    <div
      class="linear-progress"
      :class="{ 'linear-progress--active': showProgressBar }"
      :role="showProgressBar ? 'progressbar' : null"
      aria-label="Загрузка данных"
    >
      <template v-if="showProgressBar">
        <div class="linear-progress__bar linear-progress__bar--primary" />
        <div class="linear-progress__bar linear-progress__bar--secondary" />
      </template>
    </div>
    <b-table
      v-bind="$attrs"
      :items="items"
      :busy="loading"
      :class="{ 'app-table--busy': showProgressBar }"
      v-on="$listeners"
    >
      <template
        v-if="showSpinner"
        #table-busy
      >
        <div class="text-center my-2">
          <b-spinner
            class="align-middle"
            label="Spinning"
          />
        </div>
      </template>
      <template
        v-for="slotName in Object.keys($scopedSlots)"
        #[slotName]="slotData"
      >
        <slot
          :name="slotName"
          v-bind="slotData"
        />
      </template>
    </b-table>
  </div>
</template>

<script>
import { BTable, BSpinner } from 'bootstrap-vue'

// b-table with loading states: spinner on the first load, dimmed rows under a progress bar on reloads.
// Other attributes, listeners and slots are passed through to b-table.
export default {
  components: {
    BTable,
    BSpinner,
  },
  inheritAttrs: false,
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    // Nothing to keep on screen yet (first load): spinner instead of rows
    showSpinner() {
      return this.loading && !this.items.length
    },
    // Reload: previous rows stay dimmed under a progress bar
    showProgressBar() {
      return this.loading && this.items.length > 0
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~@core/scss/base/bootstrap-extended/include';

.linear-progress {
  position: relative;
  height: 4px;
  overflow: hidden;
  border-radius: 2px;

  &--active {
    background-color: rgba($primary, 0.3);
  }

  &__bar {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    background-color: $primary;

    &--primary {
      animation: linear-progress-primary 2.1s cubic-bezier(0.65, 0.815, 0.735, 0.395) infinite;
    }

    &--secondary {
      animation: linear-progress-secondary 2.1s cubic-bezier(0.165, 0.84, 0.44, 1) 1.15s infinite;
    }
  }
}

// Rows are dimmed by bootstrap-vue's [aria-busy] style, here they also stop reacting to clicks
.app-table--busy {
  pointer-events: none;
  user-select: none;
}

@keyframes linear-progress-primary {
  0% {
    left: -35%;
    right: 100%;
  }

  60%,
  100% {
    left: 100%;
    right: -90%;
  }
}

@keyframes linear-progress-secondary {
  0% {
    left: -200%;
    right: 100%;
  }

  60%,
  100% {
    left: 107%;
    right: -8%;
  }
}
</style>
